// Favorite or UnFavorite
// https://support.karte.io/post/fTYXDdLGTqjRYxP6bo4Fh

export default function karteFavorite(add: boolean, item: any) {
  console.log("karteFavorite: ", add, item);
  try {
    const items = [item];

    const item_ids = items.map(function(item) {
      return item.item_id;
    });
    const item_names = items.map(function(item) {
      return item.name;
    });
    const item_prices = items.map(function(item) {
      return item.price;
    });
    const item_urls = items.map(function(item) {
      return item.item_url;
    });
    const item_image_urls = items.map(function(item) {
      return item.item_image_url;
    });
    const l_category_names = items.map(function(item) {
      return item.l_category_name;
    });
    const s_category_names = items.map(function(item) {
      return item.s_category_name;
    });
    const l_category_cds = items.map(function(item) {
      return item.l_category_cd;
    });
    const s_category_cds = items.map(function(item) {
      return item.s_category_cd;
    });
    // const item_brands = items.map(function (item) { return item.brand; });
    // const item_brand_cds = items.map(function (item) { return item.brand_cd; });
    const item_sku_ids = items.map(function(item) {
      return item.sku_id;
    });
    // const item_sku_urls = items.map(function (item) { return item.sku_url; });
    // const item_sku_image_urls = items.map(function (item) { return item.sku_image_url; });

    const favorite: any = {
      price: item.price,
      quantity: 1,
      status: add,
      items,
      item_ids,
      item_names,
      item_prices,
      item_urls,
      item_image_urls,
      l_category_names,
      s_category_names,
      l_category_cds,
      s_category_cds,
      // item_brands,
      // item_brand_cds,
      item_sku_ids
      // item_sku_urls,
      // item_sku_image_urls,
    };

    if (add) {
      favorite["added_item_id"] = item.item_id;
      favorite["added_item_id"] = item.sku_id;
    } else {
      favorite["delieted_item_id"] = item.item_id;
      favorite["delieted_sku_id"] = item.sku_id;
    }

    console.log("karte.favorite: ", favorite);

    (window as any).tracker.track("favorite", favorite);
  } catch (e) {
    console.log("karte.favorite: ", e);
    if ("tracker" in window) {
      (window as any).tracker.track("_error", {
        message: e.message
      });
    }
  }
}
